import { Image } from '@cian/ui-kit';

import { IFullscreenSlide } from 'shared/components/Carousel';
import { IPhotoSchema } from 'shared/repositories/coworking/entities/photo/PhotoSchema';

export function prepareSlides(mediaData: IPhotoSchema[]): IFullscreenSlide[] {
  return mediaData.map(media => ({
    node: <Image key={media.cianFull} objectFit="contain" src={media.cianFull} />,
    thumbnailNode: <Image key={media.cianFull} objectFit="cover" src={media.cianThumbnail} />,
  }));
}
